import TheFooterInner from "layout/TheFooterInner/TheFooterInner";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { urlAssetsCustom } from "utils/common";
const TheFooter = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <footer>
      <ul>
        <li>
          <img src={urlAssetsCustom("assets/img/logoW.png")} />
        </li>
        <li>
          <h4>Quốc gia</h4>
          <a>Vietnam</a>
        </li>
        <li>
          <h4>Kết nối với chúng tôi</h4>
          <div>
            <a target={"_blank"} href="https://www.facebook.com/baovenucuoivn">
              <img src="assets/img/icon/facebook.png" />{" "}
            </a>
            <a
              target={"_blank"}
              href=" https://www.youtube.com/watch?v=6OpfhOFVM00"
            >
              <img src="assets/img/icon/YouTube.svg" />{" "}
            </a>
          </div>
        </li>
      </ul>
      <p className="copyright">
        Bản quyền thuộc Công ty TNHH Quốc tế Unilever Việt Nam. Powered by Utop
      </p>
    </footer>
  );
};

export default TheFooter;
